/**
 * Flatten discovery options for keyboard navigation.
 */
export default function flattenDiscoveryOptions(conversations, people) {
  if (conversations === void 0) {
    conversations = [];
  }
  if (people === void 0) {
    people = [];
  }
  const options = [];
  for (const conversation of conversations) {
    options.push({
      type: 'conversation',
      conversation
    });
  }
  for (const person of people) {
    options.push({
      type: 'person',
      person
    });
  }
  return options;
}
flarum.reg.add('flatrate-messaging-ui', 'forum/utils/flattenDiscoveryOptions', flattenDiscoveryOptions);